export default __webpack_public_path__ + "static/media/Planets - Portfolio.3a9b99f1.png";